import { render, staticRenderFns } from "./QLSChildPerson.vue?vue&type=template&id=005b2349&scoped=true&"
import script from "./QLSChildPerson.vue?vue&type=script&lang=ts&"
export * from "./QLSChildPerson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b2349",
  null
  
)

export default component.exports